import React from "react";
import "./Privacy.css";

// Example: Replace all assets and SVGs with corresponding imports/paths as needed
// import logo from "./assets/logo.png";

export default function Refund() {
  return (
    <section className="privacy-section">
      <div className="privacy-policy-header">REFUND POLICY</div>
      <div className="policy">
<span className="policy-innerheader">CANCELLATION / REFUND POLICY</span>
<div className="extra-space"></div>
<ul>
  <li>The products and/or services, including any programs or events ("Services") offered by Harsh Bhagat ("Firm"), once purchased, cannot be cancelled under any circumstances.</li>
  <li>The Firm shall not be liable to refund any amount in respect of any Services availed by you once the payment has been received.</li>
  <li>All payments made to the Firm are final and non-refundable.</li>
</ul>
<div className="extra-space"></div>

<span className="policy-innerheader">NO REFUND POLICY</span>
<div className="extra-space"></div>
<ul>
  <li>Refunds will not be issued for any reason, including but not limited to dissatisfaction with the content, lack of usage, or change of mind.</li>
  <li>The Firm does not entertain refund requests under any circumstances, including accidental payments, duplicate transactions, or failure to attend or utilize the purchased Services.</li>
  <li>In the event of technical issues preventing access to the Services, users must contact support at harshbhagatcares@gmail.com to resolve the issue. A refund will not be provided in such cases.</li>
  <li>Any excess funds erroneously credited to the Firm's account due to user errors will not be eligible for refund. The Firm's decision on such matters shall be final and binding.</li>
</ul>
<div className="extra-space"></div>

<span className="policy-innerheader">IMPORTANT NOTE FOR PARTICIPANTS</span>
<div className="extra-space"></div>
<ul>
  <li>Purchasing any training program or webinar does not guarantee success in trading. These programs are strictly for educational purposes only.</li>
  <li>Participants are advised to practice the techniques taught in the course for a minimum of 90 trading days before applying any strategies in live markets. Independent financial advice from registered investment advisors should be sought before making trading or investment decisions.</li>
  <li>Leaving a course or program midway does not entitle the participant to any refund, credit, or adjustment for future programs.</li>
  <li>Harsh Bhagat does not provide stock tips, trade recommendations, or recovery advice. All content is strictly for educational and training purposes.</li>
  <li>Neither Harsh Bhagat nor its representatives will be responsible for any financial losses incurred by participants based on their personal trades or investment decisions. Past performance is not indicative of future results, and users should conduct due diligence before trading.</li>
</ul>
<div className="extra-space"></div>

<span className="policy-innerheader">SEBI COMPLIANCE NOTICE</span>
<div className="extra-space"></div>
<ul>
  <li>All views, opinions, charts, and strategies shared during the training are purely for educational purposes and should not be considered buy/sell recommendations or investment advice.</li>
  <li>Participants are strongly advised to consult their financial advisors before executing any trades.</li>
  <li>Trading and investing in the stock market involves significant risk. Know your risk tolerance and review SEBI guidelines to stay informed about regulatory requirements and best practices. SEBI provides comprehensive resources on risk management, compliance, and ethical trading.</li>
  <li>Harsh Bhagat and its trainers are not SEBI-registered advisors.</li>
  <li>The Firm disclaims all liability for any financial damages incurred due to reliance on educational content provided in its programs.</li>
</ul>
<div className="extra-space"></div>

By purchasing any Service from Harsh Bhagat, you acknowledge and agree to this strict no-refund policy. <strong>Your Money, Your Risk, Your Responsibility.</strong>
      </div>
      <div className="extra-space"></div>
      <div className="extra-space"></div>
      <div className="extra-space"></div>
    </section>
  );
}